import type {
  CourseListItemDto,
  CoursePhase,
  TrainSide,
} from 'endchess-contracts';

export type {
  CoursePhase,
  GamePool,
  LessonType,
  SectionKind,
  TrainSide,
  CourseProgressDto,
  UserCourseSettingsDto,
  LessonListItemDto,
  CourseSectionDto,
  CourseListItemDto,
  CourseDetailDto,
  LessonDrillResultDto,
  LessonDetailDto,
  CoursePreviewThumbnailDto,
  CourseLineMasteryState,
  CourseTrainModeKey,
} from 'endchess-contracts';

/** Half-moves played on each course list thumbnail preview. */
export const COURSE_PREVIEW_LINE_PLIES = 8;

/** Animated line snippet for course list previews (up to 3 per course). */
export type CoursePreviewThumbnail = {
  /** Up to {@link COURSE_PREVIEW_LINE_PLIES} SAN half-moves from `startFen`. */
  pgn: string;
  startFen?: string;
  /** Move leading into {@link startFen} for the last-move indicator on ply 0. */
  setupUci?: string;
  /** When set, orients the preview board from this train side. */
  trainSide?: TrainSide;
};

export type LessonDrillMove = {
  index: number;
  isCorrect: boolean;
};

export type CourseListResponse = {
  courses: CourseListItemDto[];
};

export const COURSE_PHASES: readonly CoursePhase[] = [
  'opening',
  'middlegame',
  'endgame',
  'mistakes',
] as const;

export const COURSE_PHASE_LABELS: Record<CoursePhase, string> = {
  opening: 'Opening',
  middlegame: 'Middlegame',
  endgame: 'Endgame',
  mistakes: 'My Mistakes',
};

export const isCoursePhase = (value: string): value is CoursePhase =>
  (COURSE_PHASES as readonly string[]).includes(value);

export type CourseTypeSummary = {
  phase: CoursePhase;
  label: string;
  courseCount: number;
};
